import { useDrawerAskAIContext } from '../hooks/useDrawerAskAIContext'

interface Props {
  isOpen: boolean
  contextLabel?: string
  contextDetails?: string
}

function DrawerAskAIContextActivator({
  isOpen,
  contextLabel,
  contextDetails,
}: Props) {
  useDrawerAskAIContext({
    isOpen,
    contextLabel,
    contextDetails,
  })

  return null
}

export default DrawerAskAIContextActivator
